var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('span',{staticClass:"nodataSpan"},[_vm._v("暂无内容,请查看新开页。")])])
}]

export { render, staticRenderFns }